import { defineStore } from 'pinia';
import type { UserDto } from '@/services/types/api.types';

interface UserStoreState {
  currentUser: UserDto | null;
}

export const useUsersStore = defineStore({
  id: 'users',
  state: (): UserStoreState => ({ currentUser: null }),
});
